import React, { Component } from 'react'
import './tooltip.scss'

class Tooltip extends Component {
	stopPropagation(e) {
		e.stopPropagation()
	}
	render() {
		const classes = ['vbui--tooltip', this.props.classes, this.props.show ? 'open' : ''].join(' ')
		return (
			<div style={this.props.style} className={classes} onClick={this.stopPropagation}>
				{this.props.children}
			</div>
		)
	}
}

export default Tooltip
